module.exports = __webpack_public_path__ + "img/cuff_width.9c69376a.png";